/**
 * Raíz de rutas del Admin: providers de datos (TanStack Query) y de toasts, y el puente entre el
 * cliente API y el router — `api/client.ts` emite `fermin:unauthenticated` ante un `401` y aquí se
 * traduce en una navegación a `/ingresar` (contracts/errors.md).
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { UNAUTHENTICATED_EVENT } from '../api/client';
import { queryClient } from '../api/query-client';
import { ToastProvider } from '../components/ui/toast';
import { NotFound } from '../features/shell/not-found';

function UnauthenticatedRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    function onUnauthenticated() {
      queryClient.clear();
      void navigate({ to: '/ingresar' });
    }
    window.addEventListener(UNAUTHENTICATED_EVENT, onUnauthenticated);
    return () => window.removeEventListener(UNAUTHENTICATED_EVENT, onUnauthenticated);
  }, [navigate]);

  return null;
}

function RootComponent() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <UnauthenticatedRedirect />
        <Outlet />
      </ToastProvider>
    </QueryClientProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => (
    <div className="mx-auto w-full max-w-[1280px] p-fm-6">
      <NotFound />
    </div>
  ),
});
